// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2c5OZ","wrapper--open":"styles_wrapper--open__HhA69","wrapper--closed":"styles_wrapper--closed__Hwghj","drawer":"styles_drawer__5eE04"};